export default __webpack_public_path__ + "152fa430ff657df961b97a383c69f2cd.svg";